class PageLoading {
  constructor(selector) {
    this.root = document.querySelector(selector);

    if (!this.root) {
      return;
    }

    this.barFill = this.root.querySelector('.js-page-loading-bar-fill');
    this.startedAt = Date.now();
    this.logoDelay = 200;
    this.logoDuration = 1000;
    this.barGap = 150;
    this.barFillDuration = 2.2;
    this.barCompleteDuration = 0.6;
    this.fadeOutDuration = 800;
    this.barProgress = 0;
    this.isWindowLoaded = document.readyState === 'complete';
    this.isFinished = false;
    this.barStartedAt = null;
    this.barTween = null;
    this.finishTimer = null;

    document.documentElement.classList.add('is-page-loading');
    this.preloadMvImages();
    this.showLogo();
    this.bindLoad();
    this.scheduleSafetyFallback();
  }

  get minDuration() {
    return (
      this.logoDelay +
      this.logoDuration +
      this.barGap +
      this.barFillDuration * 1000 +
      this.barCompleteDuration * 1000 +
      400
    );
  }

  preloadMvImages() {
    const mvRoot = document.querySelector('.js-p-top-mv');

    if (!mvRoot) {
      return;
    }

    const imgs = mvRoot.querySelectorAll('img[src]');
    const sources = Array.from(imgs, (img) => img.currentSrc || img.src).filter(Boolean);

    if (sources.length === 0) {
      return;
    }

    sources.forEach((src) => {
      const image = new Image();
      image.src = src;
    });
  }

  showLogo() {
    window.setTimeout(() => {
      this.root.classList.add('is-logo-visible');

      window.setTimeout(() => {
        this.startBarProgress();
      }, this.logoDuration + this.barGap);
    }, this.logoDelay);
  }

  startBarProgress() {
    if (this.barStartedAt) {
      return;
    }

    this.barStartedAt = Date.now();
    this.setBar(0);

    const onBarUpdate = () => {
      this.setBar(this.barProgress);
    };

    this.barTween = gsap.to(this, {
      barProgress: 92,
      duration: this.barFillDuration,
      ease: 'power2.inOut',
      onUpdate: onBarUpdate,
      onComplete: () => {
        if (this.isWindowLoaded) {
          this.completeBar();
        } else {
          this.checkFinish();
        }
      },
    });
  }

  completeBar() {
    if (this.isFinished || this.barProgress >= 99.5) {
      this.checkFinish();
      return;
    }

    if (this.barTween) {
      this.barTween.kill();
      this.barTween = null;
    }

    gsap.to(this, {
      barProgress: 100,
      duration: this.barCompleteDuration,
      ease: 'power2.out',
      onUpdate: () => {
        this.setBar(this.barProgress);
      },
      onComplete: () => {
        this.checkFinish();
      },
    });
  }

  bindLoad() {
    if (this.isWindowLoaded) {
      this.onWindowLoad();
      return;
    }

    window.addEventListener(
      'load',
      () => {
        this.onWindowLoad();
      },
      { once: true }
    );
  }

  onWindowLoad() {
    this.isWindowLoaded = true;

    if (this.barProgress >= 92) {
      this.completeBar();
    }
  }

  scheduleSafetyFallback() {
    window.setTimeout(() => {
      if (this.isFinished) {
        return;
      }

      this.isWindowLoaded = true;

      if (this.barProgress < 99.5) {
        if (this.barTween) {
          this.barTween.kill();
          this.barTween = null;
        }

        gsap.killTweensOf(this);
        this.barProgress = 100;
        this.setBar(100);
      }

      this.checkFinish(true);
    }, 10000);
  }

  setBar(percent) {
    if (!this.barFill) {
      return;
    }

    const value = Math.max(0, Math.min(100, percent)) / 100;
    this.barFill.style.transform = `scaleX(${value})`;
  }

  checkFinish(force = false) {
    if (this.isFinished) {
      return;
    }

    const ready = this.barProgress >= 99.5 && this.isWindowLoaded;

    if (!ready && !force) {
      return;
    }

    const elapsed = Date.now() - this.startedAt;
    const canFinish = force || elapsed >= this.minDuration;

    if (ready && canFinish) {
      this.finish();
      return;
    }

    if (!ready || canFinish) {
      return;
    }

    if (this.finishTimer) {
      return;
    }

    this.finishTimer = window.setTimeout(() => {
      this.finishTimer = null;
      this.checkFinish();
    }, this.minDuration - elapsed + 16);
  }

  finish() {
    if (this.isFinished) {
      return;
    }

    this.isFinished = true;

    if (this.finishTimer) {
      window.clearTimeout(this.finishTimer);
      this.finishTimer = null;
    }

    if (this.barTween) {
      this.barTween.kill();
    }

    gsap.killTweensOf(this);
    this.barProgress = 100;
    this.setBar(100);

    window.setTimeout(() => {
      this.root.classList.add('is-fade-out');

      window.setTimeout(() => {
        this.root.classList.add('is-hidden');
        document.documentElement.classList.remove('is-page-loading');
        $(window).trigger('loading');
      }, this.fadeOutDuration);
    }, 300);
  }
}
